import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { PieChart } from '@/common/dashboard/charts/PieChart';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ChecklistDisplay } from '../ChecklistDisplay';

const levels = {
  SUITE: {
    title: 'Test Suites',
    icon: fas.faBoxesStacked,
    route: 'ac/suite',
    items: (data) => data.suites,
  },
  TEST: {
    title: 'Tests',
    icon: fas.faVial,
    route: 'ac/test',
    items: (data) => data.testNodes,
  },
  RQMT: {
    title: 'Requirements',
    icon: fas.faListCheck,
    route: 'ac/rqmt',
    items: (data) => data.rqmtNodes,
  },
};

export const StatusColumnCard = ({ level }) => {
  const theme = useTheme();
  const { title, icon, route, items } = levels[level];

  return (
    <DashboardCard
      title={title}
      description={'Displays the latest run status of each of the selected ' + title}
      icon={icon}
    >
      {(data) => {
        const levelItems = items(data);
        const successCount = levelItems.filter((item) => item.status === 'SUCCESS').length;
        const failCount = levelItems.filter((item) => item.status === 'FAIL').length;
        const notRunCount = levelItems.length - successCount - failCount;
        const successRate = levelItems.length > 0 ? Math.round((successCount / levelItems.length) * 100) : 0;

        const pieData = [
          { label: 'Success', value: successCount, color: theme.palette.success.main },
          { label: 'Fail', value: failCount, color: theme.palette.error.main },
          { label: 'Not Run', value: notRunCount, color: theme.palette.text.secondary },
        ].filter((slice) => slice.value > 0);

        return (
          <Stack direction="column" gap={2} sx={{ height: '100%' }}>
            <Box sx={{ minHeight: 250 }}>
              <PieChart
                data={pieData}
                legend="bottom"
                dataLabels={false}
                innerSize="70%"
                centerLabel={successRate + '%'}
                centerSubLabel="Success"
              />
            </Box>
            <ChecklistDisplay items={levelItems} route={route} />
          </Stack>
        );
      }}
    </DashboardCard>
  );
};
